const runtimeApiUrl =
  typeof window !== 'undefined' ? window.__ENV__?.REACT_APP_API_URL : undefined;

export const API_BASE_URL =
  runtimeApiUrl ?? process.env.REACT_APP_API_URL ?? 'https://rest.achoupet.ong.br';

export const REQUEST_TIMEOUT = 10000;

export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
